import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A boutique React & D3v4 workshop – and my first vlog",
  "description": "",
  "published": "2017-03-28T00:00:00.000Z",
  "redirect_from": ["/blog/boutique-react-d3v4-workshop/swizec/7519"],
  "categories": "Business",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "zdD-7Jb5XN8?ecver=2",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`On Saturday – Mar 25th – `}<a parentName="p" {...{
        "href": "https://twitter.com/frangel85"
      }}>{`Freddy`}</a>{` and I taught a boutique workshop to six magnificent people. We didn't intend for it to be a boutique workshop, but we learned that 2 weeks is really tight to promote a $400 event.`}</p>
    <p>{`And you know what, it was better this way.`}</p>
    <p>{`Having six people was great. We could banter and hang out, everyone could get to know everyone, we could help everyone individually if they got stuck. Typing code is a harder problem than you'd think, and finding typos is the hardest.`}</p>
    <p>{`I think this was the 6th React & D3 workshop we've done, and it was my favorite. We improve the content with each iteration, we get better at teaching, and we get more relaxed.`}</p>
    <p>{`You know, I think less than ten is my favorite audience size. When somebody asks a question, we can go on a tangent to answer. With a small class, it's easy to gauge everyone's interest, and we can spend more time answering great questions. And because the class is small, people feel more comfortable asking questions.`}</p>
    <p>{`With more questions, our workshop becomes better for the audience. We help `}<em parentName="p">{`them`}</em>{` and not an abstract version of them.`}</p>
    <p>{`That's why on Saturday people didn't learn just about React and D3 and building data visualizations. We talked at length about Redux, MobX, and approaches to state management. We talked about setting up a new project (always use `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{`), strategies to fetch and organize data, and we even broached some deep CompSci topics.`}</p>
    <p>{`It was great ?`}</p>
    <p><strong parentName="p">{`My favorite quote of the day was: "I learned a lot"`}</strong></p>
    <p>{`But I didn't get it on camera. ?`}</p>
    <p>{`You see, I wanted to give vlogging a shot. I `}<em parentName="p">{`want`}</em>{` to try my hand at vlogging. I think it's going to make my coding videos more interesting.`}</p>
    <p>{`And holy shit is vlogging harder than it looks!`}</p>
    <p>{`You look at vlogs and you think `}<em parentName="p">{`"Oh, it's just idiots running around with cameras saying random things"`}</em>{` and yes, that might be the case on Snapchat, maybe.`}</p>
    <p>{`But to make a real vlog, the kind that stays on YouTube forever more… damn.`}</p>
    <p>{`Here is a list of things you have to always keep in mind. I didn't think about all of these, and now I know I should.`}</p>
    <ol>
      <li parentName="ol">{`The camera should point at person talking, always`}</li>
      <li parentName="ol"><em parentName="li">{`You`}</em>{` should spend more time on camera`}</li>
      <li parentName="ol">{`Think more selfies with other people, less camera pointing away from you at other people`}</li>
      <li parentName="ol">{`When a scene transition happens, you have to narrate it`}</li>
      <li parentName="ol">{`Said narration should happen on camera, not behind the camera`}</li>
      <li parentName="ol">{`Mind the light. People's faces look dark real quick`}</li>
      <li parentName="ol">{`Background noise is louder than you think`}</li>
      <li parentName="ol">{`Camera on automatic aperture and shutter speed never makes the perfect decision`}</li>
      <li parentName="ol">{`You don't have time for manual aperture and shutter speed`}</li>
      <li parentName="ol">{`You think autofocus found your face, but are you `}<em parentName="li">{`sure`}</em>{` autofocus found your face?`}</li>
      <li parentName="ol">{`Don't configure your mic manually. Your settings are wrong because you set them up in a quiet environment.`}</li>
      <li parentName="ol">{`Mic settings do not travel well`}</li>
      <li parentName="ol">{`It's easy to take long shots of things that don't drive the story`}</li>
      <li parentName="ol">{`Those long shots take a long time to edit and cut down`}</li>
    </ol>
    <p>{`Basically, I should improve my camerawork and my narrating.`}</p>
    <p>{`But the workshop was great. Can't wait to do the one in Chicago in May. We already know how we're gonna make it better.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      